import { render, staticRenderFns } from "./HedgeAppeal.vue?vue&type=template&id=5651d34b&scoped=true"
import script from "./HedgeAppeal.vue?vue&type=script&lang=js"
export * from "./HedgeAppeal.vue?vue&type=script&lang=js"
import style0 from "./HedgeAppeal.vue?vue&type=style&index=0&id=5651d34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651d34b",
  null
  
)

export default component.exports